import { NavLink } from "react-router-dom";
import { cn } from "@mira/ui";
import { navItems } from "@/lib/nav-items";

export function MobileNav() {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-pure-white dark:bg-dark-card border-t border-stone dark:border-dark-border z-50 safe-area-bottom">
      <div className="flex items-center justify-around h-[64px] px-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                "flex flex-col items-center justify-center gap-0.5 py-1.5 px-2 rounded-xl transition-all duration-200 min-w-[56px]",
                isActive
                  ? "text-near-black dark:text-dark-text"
                  : "text-graphite dark:text-dark-muted hover:text-near-black dark:hover:text-dark-text",
              )
            }
          >
            {({ isActive }) => (
              <>
                <div
                  className={cn(
                    "p-1.5 rounded-lg transition-all duration-200",
                    isActive && "bg-warm-cream dark:bg-dark-surface",
                  )}
                >
                  <item.icon className="w-5 h-5" />
                </div>
                <span className="text-[10px] font-medium leading-tight">
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
